import React, { useState } from "react";
import { useSelector } from "react-redux";
import { postRequest } from "../../services/mainApp.service";
import { message } from "antd";

const OrderTransfer = ({ branchesList, orderDetials, isBranchModalOpen, setIsBranchModalOpen, setSelectedBranch }) => {
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const userData = useSelector((state) => state.authReducer);

 
  const handleOrderTransfer = () => {
    if (!selectedBranchId) {
      message.warning("Please select a branch to transfer the order.");
      return;
    }
    
    const selectedBranch = branchesList?.find((branch) => branch.BranchId === selectedBranchId);
    setSelectedBranch(selectedBranch.BranchName || null);

    setIsBranchModalOpen(false);
    setSelectedBranchId(null);

    postRequest("BranchOrderTransfer", {
      OperationId: 3,
      BranchId: selectedBranchId,
      OrderMasterId: orderDetials?.OrderMasterId,
      UserId: userData?.UserId,
      UserIP: "0",
      CompanyId: userData?.CompanyId,
    })
      .then((response) => {
        if (response.data.error === true) {
          message.error(response.data.errorMessage);
          return;
        }

        if (response.data.response === false) {
          message.error(response.data.DataSet.Table.errorMessage);
          return;
        }

        const data = response.data.DataSet;
        if (data.Table[0].HasError) {
          message.error(data.Table[0].Message);
          return;
        }
        message.success(data.Table[0].Message);
      })
      .catch((error) => {
        console.error("Error:", error);
        message.error("Something went wrong while transferring the order.");
      });
  };

  const handleClose = () => {
    setIsBranchModalOpen(false);
    setSelectedBranchId(null);
  };

  if (!isBranchModalOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-md mx-auto rounded-xl p-6 shadow-lg relative">
        <h2 className="text-2xl font-bold mb-4 text-center">Transfer Order to Another Branch</h2>

        <div className="max-h-64 overflow-y-auto border rounded-lg divide-y">
          {branchesList?.map((branch) => (
            <div
              key={branch.BranchId}
              onClick={() => setSelectedBranchId(branch.BranchId)}
              className={`cursor-pointer px-4 py-3 flex items-center justify-between transition-all duration-200 ${
                selectedBranchId === branch.BranchId
                  ? "bg-blue-100 text-blue-800 font-semibold"
                  : "hover:bg-gray-100"
              }`}
            >
              <span>{branch.BranchName || `Branch #${branch.BranchId}`}</span>
              {selectedBranchId === branch.BranchId && (
                <span className="text-sm bg-blue-600 text-white px-2 py-0.5 rounded">Selected</span>
              )}
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={handleClose}
            className="w-full px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleOrderTransfer}
            disabled={!selectedBranchId}
            className={`w-full px-4 py-2 rounded-lg text-white transition ${
              !selectedBranchId ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            Transfer
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderTransfer;
